import axios from "axios";

export const state = {
    applicants: [],
};

export const getters = {
    applicants: state => state.applicants,
};

export const mutations = {
    setApplicants(state, newValue) {
        state.applicants = newValue
    },
};

export const actions = {
    async fetchApplicants({ commit }) {
        await axios.get('/applicants').then(res => {
            commit('setApplicants', res.data.applicants)
        })
    },
};
